module.exports = __webpack_public_path__ + "media/images/avatar/09-d75ecee676d827dfe6b74b71a3378a57.jpg";